<template>
    <div>
      <taxApportionmentMiscMtg/>
    </div>
</template>

<script>
import taxApportionmentMiscMtg from '../../components/apportionment/miscMtg/miscMtg.vue';

export default {
  name: 'apportionment',
  data: () => ({

  }),
  components: {
    taxApportionmentMiscMtg,
  },
};
</script>
